import MainIcons from '@/icons/main';
import styles from './styles.module.css';
import { serviceType, shopServiceType } from '@/commonTypes';
import AppLink from '@/components/common/AppLink';
import RateComponent from '@/components/common/RateComponent';
import PriceSection from '@/components/pages/wallet/WalletContent/WalletInfo/PriceSection';
import Button from '@/components/common/Button';
import { useLayoutContext } from '@/context/LayoutContext';
import { TRIGGERS } from '@/api/global';
import ReserveButton from './ReserveButton';

type Props = {
  item: shopServiceType;
  index: number;
  onAdd?: (item: any) => void;
  callbackFavorite?: (x: serviceType) => void;
  showBageds?: boolean;
  showButton?: boolean;
  direction?: 'vertical' | 'horizontal';
};

const badgeIcons = {
  mobile: MainIcons.homeIcon,
  warranty: MainIcons.shieldIcon,
};

const badgeClasses = {
  mobile: styles.mobileBadge,
  warranty: styles.warrantyBadge,
};

const ServiceCard = ({ item }: Props) => {
  const { setTrigger, setEditInfo } = useLayoutContext();

  return (
    <div className={`card ${styles.card}`}>
      <MainIcons.ServiceIcon fill="var(--accent)" width="23px" height="23px" />

      <div className={styles.content}>
        <div className={styles.header}>
          <AppLink href={`/shop-services/${item?.slug}`} className={styles.title}>
            {item?.title}
          </AppLink>

          {/* {item?.badges?.map((badge) => {
            const Icon = badgeIcons[badge.type as keyof typeof badgeIcons];

            return (
              <span
                key={badge.type}
                className={`${styles.badge} ${
                  badgeClasses[badge.type as keyof typeof badgeClasses]
                }`}
              >
                {Icon && (
                  <Icon
                    width="11px"
                    height="11px"
                    fill={badge.type === 'mobile' ? 'var(--purple)' : 'var(--green)'}
                  />
                )}
                {badge.label}
              </span>
            );
          })} */}
          {item?.inPlace && (
            <span className={`badge mobileBadge`}>
              <MainIcons.homeIcon width="11px" height="11px" fill="var(--purple)" />
              {'سیار'}
            </span>
          )}
        </div>

        <p className={styles.description}>{item?.description}</p>

        <div className={styles.meta}>
          <AppLink href={`/shops/${item?.shop?.slug}`} className={styles.shop}>
            <MainIcons.shopIcon fill="var(--brand-deep)" width="13px" height="13px" />
            {item?.shop?.name}
          </AppLink>

          <span className={styles.metaItem}>
            <MainIcons.clockIcon fill="var(--text-mut2)" width="13px" height="13px" />
            مدت {item?.duration}
          </span>

          <span className={`${styles.metaItem} ${styles.rating}`}>
            <RateComponent
              number={1}
              className="w-auto"
              rate={Number(item?.rating)}
              activeFillColor="var(--accent)"
            />
            {item?.rating}
          </span>

          <span className={`${styles.metaItem} ${styles.available}`}>
            <MainIcons.CalendarIcon fill="var(--green)" width="13px" height="13px" />
            نوبت خالی
          </span>
        </div>
      </div>

      <div className={styles.sidebar}>
        <PriceSection value={item?.price} className={styles.price} />
        <ReserveButton item={item} type="service" />
      </div>
    </div>
  );
};

export default ServiceCard;
